import {
  AdmonitionDirectiveDescriptor,
  MDXEditor,
  directivesPlugin,
  headingsPlugin,
  linkDialogPlugin,
  linkPlugin,
  listsPlugin,
  markdownShortcutPlugin,
  quotePlugin,
  thematicBreakPlugin,
} from '@mdxeditor/editor'

type TNoteDisplayProps = {
  value: string
}
// Display-only markdown renderer
export default function NoteDisplay(props: TNoteDisplayProps) {
  const { value } = props
  return (
    <MDXEditor
      markdown={value}
      readOnly
      plugins={[
        directivesPlugin({ directiveDescriptors: [AdmonitionDirectiveDescriptor] }),
        headingsPlugin(),
        quotePlugin(),
        listsPlugin(),
        linkPlugin(),
        linkDialogPlugin(),
        thematicBreakPlugin(),
        markdownShortcutPlugin(),
      ]}
    />
  )
}
